<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/profile" name="User Profile" icon="user"/>
        <sidebar-link to="/request-license" name="Request Licenses" icon="certificate"/>
        <sidebar-link v-if="!isMember" to="/users" name="User Management" icon="users"/>
        <sidebar-link v-if="!isMember" to="/licenses" name="License Management" icon="table"/>
        <sidebar-link to="/downloads" name="Downloads" icon="download"/>
        <sidebar-link v-if="hasPerDevicePool" to="/device-link/reports" name="Device Link Reports" icon="archive" divider/>
      </template>
      <mobile-menu>
        <li class="nav-item">
          <logout-button />
        </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import LogoutButton from "../../components/LogoutButton.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    LogoutButton
  },
  created() {
    this.handleUserHome();
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    async handleUserHome() {
      if (!this.user) {
        await this.$store.cache.dispatch('user/fetchMe');
      }

      if (this.$route.path == "/") {
        let homePage = "/profile";
        if (this.isSuperUser || this.isStaffUser) {
          homePage = "/licenses";
        }
        this.$router.push(homePage);
      }
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'isSuperUser', 'isStaffUser', 'isMember']),
    hasPerDevicePool() {
      return this.user !== null && this.user.group.uses_device_link
    }
  },
  watch: {
    '$route': {
      handler() {
        this.handleUserHome();
      }
    }
  }
};
</script>
